import { createTanstackQueryUtils } from "@orpc/tanstack-query";
import { ownActivitySchema } from "@rosc/contracts";
import { useQuery } from "@tanstack/react-query";
import { referenceClient } from "@/lib/orpc/client";
import { useVisitScope, type VisitScope } from "@/lib/visit-queries";

const orpc = createTanstackQueryUtils(referenceClient, {
  scoped: {
    ownActivity: {
      queryInterceptors: [
        async (options) => ownActivitySchema.parse(await options.next()),
      ],
    },
  },
});
export type ActivityRange = 7 | 30 | 90;
const disabledScope: VisitScope = {
  uid: "",
  accountPublicId: "",
  generation: 0,
};
export const activityOptions = (scope: VisitScope, days: ActivityRange) =>
  orpc.ownActivity.queryOptions({
    queryKey: [
      "account-activity",
      scope.uid,
      scope.accountPublicId,
      scope.generation,
      days,
    ],
    input: { query: { days } },
    context: { expectedUserUid: scope.uid },
    staleTime: 60_000,
    retry: false,
  });

// Analytics (v3.2): the account's own recordings and note-ready times.
export function useOwnActivity(days: ActivityRange) {
  const scope = useVisitScope();
  const query = useQuery({
    ...activityOptions(scope ?? disabledScope, days),
    enabled: !!scope,
  });
  return {
    data: query.isError ? undefined : query.data,
    loading: !!scope && query.isPending,
    error: query.isError,
    refresh: () => query.refetch(),
  };
}
